// Lightweight accordion behavior for .plp-accordion
// Opens/closes the sibling .plp-accordion-content when clicking .plp-accordion-toggle
(function () {
  function toggleItem(item, expand) {
    var button = item.querySelector('.plp-accordion-title');
    var toggle = item.querySelector('.plp-accordion-toggle');
    var content = item.querySelector('.plp-accordion-content');
    if (!content) return;

    var isOpen = content.classList.contains('active');
    var shouldOpen = typeof expand === 'boolean' ? expand : !isOpen;

    if (shouldOpen) {
      // Opening: set height to scrollHeight to expand
      content.style.height = content.scrollHeight + 'px';
      content.classList.add('active');
      if (button) button.classList.add('active');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      
      // After transition, set to auto for dynamic content
      setTimeout(function() {
        if (content.classList.contains('active')) {
          content.style.height = 'auto';
        }
      }, 300);
    } else {
      // Closing: set height to current scrollHeight first, then animate to 0
      var currentHeight = content.scrollHeight;
      content.style.height = currentHeight + 'px';
      
      // Force reflow to ensure height is set
      content.offsetHeight;
      
      // Then set to 0 and remove active class
      requestAnimationFrame(function() {
        content.style.height = '0px';
        content.classList.remove('active');
        if (button) button.classList.remove('active');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        
        // Clean up height after animation completes
        setTimeout(function() {
          if (!content.classList.contains('active')) {
            content.style.height = '';
          }
        }, 300);
      });
    }
  }

  function closeSiblings(currentItem) {
    var list = currentItem.closest('.plp-accordion-list');
    if (!list) return;
    list.querySelectorAll('.plp-accordion-item .plp-accordion-content.active').forEach(function (openContent) {
      var item = openContent.closest('.plp-accordion-item');
      if (item && item !== currentItem) toggleItem(item, false);
    });
  }

  function onClick(e) {
    var toggleBtn = e.target instanceof Element ? e.target.closest('.plp-accordion-toggle') : null;
    
    // Also handle clicks on the link when there's a toggle button
    var link = null;
    if (!toggleBtn) {
      link = e.target instanceof Element ? e.target.closest('.plp-accordion-title-link-parent') : null;
      if (link) {
        // Check if this link has a sibling toggle button (meaning it has children)
        var titleContainer = link.closest('.plp-accordion-title');
        if (titleContainer && titleContainer.querySelector('.plp-accordion-toggle')) {
          toggleBtn = titleContainer.querySelector('.plp-accordion-toggle');
        } else {
          return; // No toggle, allow normal link behavior
        }
      } else {
        return; // Not clicking on toggle or link
      }
    }

    var item = toggleBtn.closest('.plp-accordion-item');
    if (!item) return;

    e.preventDefault();
    e.stopPropagation();
    
    // Check if this item is already open before closing siblings
    var content = item.querySelector('.plp-accordion-content');
    var isAlreadyOpen = content && content.classList.contains('active');
    
    // Only close siblings if we're opening this item (not closing it)
    if (!isAlreadyOpen) {
      closeSiblings(item);
    }
    toggleItem(item);
  }

  function init(container) {
    container.addEventListener('click', onClick);
  }

  function boot() {
    document.querySelectorAll('.plp-accordion').forEach(function (host) {
      init(host);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


